import { GetPlacesResponse } from '@/features/places/types/places.type';
import { ActionType } from '@/types/actionType';
import { GeofenceAction } from './geofenceAction';

type State = {
	geofences: GetPlacesResponse[];
	geofenceToEdit: GetPlacesResponse | null;
};

const INITIAL_STATE: State = {
	geofences: [],
	geofenceToEdit: null,
};

const geofenceReducer = (state: State = INITIAL_STATE, action: GeofenceAction): State => {
	switch (action.type) {
		case ActionType.GEOFENCE_SET_GEOFENCES:
			return {
				...state,
				geofences: action.payload,
			};

		case ActionType.GEOFENCE_SET_GEOFENCE_TO_EDIT:
			return {
				...state,
				geofenceToEdit: action.payload,
			};

		case ActionType.GEOFENCE_UPDATE_BEHAVIOR:
			if (!state.geofenceToEdit) {
				return state;
			}

			const updatedBehaviors = state.geofenceToEdit.behaviors.map((behavior) =>
				behavior.id === action.payload.id ? action.payload : behavior
			);

			return {
				...state,
				geofenceToEdit: {
					...state.geofenceToEdit,
					behaviors: updatedBehaviors,
				},
			};

		case ActionType.GEOFENCE_PANEL_DELETE_GEOFENCES:
			return {
				...state,
				geofences: state.geofences.filter((geofence) => !action.payload.includes(geofence.id)),
			};

		case ActionType.GEOFENCE_PANEL_DELETE_GEOFENCE_BEHAVIORS: {
			return {
				...state,
				geofences: state.geofences.map((geofence) =>
					geofence.id === action.payload.geofenceId
						? {
								...geofence,
								behaviors: geofence.behaviors?.filter(
									(behavior) => !action.payload.behaviorIds.includes(behavior.id)
								),
						  }
						: geofence
				),
				geofenceToEdit: state.geofenceToEdit
					? {
							...state.geofenceToEdit,
							behaviors:
								state.geofenceToEdit.behaviors?.filter(
									(behavior) => !action.payload.behaviorIds.includes(behavior.id)
								) ?? [],
					  }
					: state.geofenceToEdit,
			};
		}
		default:
			return state;
	}
};

export default geofenceReducer;
